import React from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';
import * as styles from './Award.module.scss';

const Award = React.forwardRef((props, ref) => {
  const {
    date,
    description,
    className,
    bottom,
    children,
    ...other
  } = props;

  return (
    <div ref={ref} className={clsx(styles.wrapper, className)} {...other}>
      <div className={styles.toolbar}>
        <time className={styles.date}>{date}</time>
      </div>
      <div className={styles.figure}>
        {children}
      </div>
      <footer className={styles.footer}>
        <p className={styles.text}>{parse(description)}</p>
      </footer>
    </div>
  );
});

export default React.memo(Award);
